export enum InactiveUserMessage {
  OutOfServiceDbs = 'La base de datos de %s está temporalmente fuera de servicio pero puedes ingresar la información manualmente o lanzar un nuevo estudio de seguridad',
  NotTruoraInfo = 'No se puede obtener información de Truora',
  InactiveDocument = 'La %s está inactiva',
  RoleRequired = 'Requiere asignación de Rol',
  UserStateNotDefined = 'No se puede obtener el estado del usuario',
  InactiveForTruora = 'Inactivo por estudio de seguridad',
  OptionalDocument = "El cargue de la %s es opcional",
}